// extracted by mini-css-extract-plugin
export var lg = "_3d-4";
export var md = "_3d-3";
export var sm = "_3d-2";
export var xs = "_3d-1";
export var xxs = "_3d-0";